
import Vue from "vue";
import eventBus from "@/eventBus";
import { APP_TITLE } from "@/constants/app";

const ONBOARDING_STORAGE_KEY = "jungslab_onboarding_completed";

export default Vue.extend({
  name: "OnboardingModal",
  data() {
    return {
      dialog: false,
      currentStep: 0,
      steps: [
        {
          title: `반갑습니다. ${APP_TITLE} 관리자입니다 👋`,
          desc: "카페24에서 조회한 결제·환불 내역과 예상 PG 수수료·예상 순정산액을 날짜별로 확인합니다.",
        },
        {
          title: "직관적인 정산 캘린더 & 매출 분석 차트.",
          desc: "매월/매주/매일 발생한 정산 현황을 달력과 결제수단별 시각화 그래프로 신속하게 분석하세요.",
        },
        {
          title: "PG 계약 수수료율 맞춤 반영.",
          desc: "상단 '수수료 설정' 메뉴에서 계약 수수료율을 입력하면 예상 PG 수수료와 예상 순정산액에 반영됩니다.",
        },
      ],
    };
  },
  methods: {
    checkAndOpen() {
      const completed = localStorage.getItem(ONBOARDING_STORAGE_KEY);
      if (!completed) {
        this.dialog = true;
      }
    },
    open(step = 0) {
      this.currentStep = typeof step === "number" && step >= 0 ? step : 0;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    closeSilently() {
      this.dialog = false;
    },
    finishOnboarding() {
      localStorage.setItem(ONBOARDING_STORAGE_KEY, "true");
      this.dialog = false;
      this.$emit("close");
      eventBus.$emit("open-pg-fee-settings");
    },
  },
  mounted() {
    this.checkAndOpen();
  },
});
